import React, { useContext } from 'react';
import { MainContext } from '../../context/MainContext';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

import TerminalOutlinedIcon from '@mui/icons-material/TerminalOutlined';
import WifiIcon from '@mui/icons-material/Wifi';
import RouterIcon from '@mui/icons-material/Router';
import CompassCalibrationIcon from '@mui/icons-material/CompassCalibration';

export default function DashboardWifiDetails() {
  const state = useContext(MainContext).state;
  const snWifiRf = state.snWifiRf.split(',');

  const wifiSignal = `${state.rssi} dB`
  const firmwareVersion = snWifiRf[1] === '' || snWifiRf[1] === undefined ? '-' : snWifiRf[1];
  const wifiSSID = snWifiRf[8] === '' || snWifiRf[8] === undefined ? '-' : snWifiRf[8]; 
  var version = '';
  if (state.deviceType === 1) {
    version = 'V1/2';
  } else if (state.deviceType === 2) {
    if (firmwareVersion.startsWith('1')) {
      version = 'V3.1';
    } else if (firmwareVersion.startsWith('2')) {
      version = 'V3.5';
    }
  } 

  return (
    <React.Fragment>
      <Typography
        component="h2"
        variant="h6"
        color="white"
        gutterBottom
        sx={{ fontWeight: 600 }}
      >
        WiFi Details
      </Typography>

      <Grid container spacing={1.5}>
        {[
          { label: 'SmartLink Module', icon: <CompassCalibrationIcon />, value: version },
          { label: 'Wi-Fi Signal Strength', icon: <WifiIcon />, value: wifiSignal },
          { label: 'Firmware Version', icon: <TerminalOutlinedIcon />, value: firmwareVersion },
          { label: 'Wi-Fi SSID', icon: <RouterIcon />, value: wifiSSID },
        ].map((item, idx) => (
          <Grid item xs={12} key={idx}>
            <Paper
              sx={{
                p: 1.5,
                height: 60,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                borderRadius: 2,
                bgcolor: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.08)',
                transition: '0.2s ease',
                '&:hover': {
                  bgcolor: 'rgba(255,255,255,0.08)',
                  transform: 'translateY(-2px)',
                },
              }}
            >
              {/* Icon bubble */}
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: 'rgba(255,255,255,0.05)',
                  color: 'rgba(50,116,162,1)',
                }}
              >
                {item.icon}
              </Box>

              {/* Text */}
              <Box sx={{
                flexGrow: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: 0.3,
                mt: 0.4
              }}>
                <Typography sx={{ fontSize: 14, fontWeight: 700 }} color="white" noWrap>
                  {item.label}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.disabled',
                    fontSize: 13,
                  }}
                  noWrap
                >
                  {item.value}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </React.Fragment>
  );
}
